import {FC, RefObject, useState} from 'react';
import {Box, Stack} from '@chakra-ui/react';
import {useT} from '@kcast-fe/core';
import {HorizontalTabs, useScreenSize} from 'ui-kit';

import {SummaryContentTab, SummaryStateTab, SummaryPromptTab} from './components';

type TSummaryTab = 'content' | 'state' | 'prompt';

interface IProps {
  id: string;
  ref: RefObject<HTMLDivElement | null>;
  onDeleted: () => void;
}

const SummaryDetailFC: FC<IProps> = ({id, ref, onDeleted}) => {
  const [tab, setTab] = useState<TSummaryTab>('content');

  const {t} = useT();
  const {isLessThan768} = useScreenSize();

  const tabs = [
    {id: 'content', label: t('summary.tabs.content')},
    {id: 'state', label: t('summary.tabs.state')},
    {id: 'prompt', label: t('summary.tabs.promptSettings')}
  ];

  return (
    <Stack h={'100%'} gap={'0'}>
      <Box pt={'12px'} px={isLessThan768 ? '12px' : '24px'}>
        <HorizontalTabs tabs={tabs} selectedId={tab} onSelect={(id) => setTab(id as TSummaryTab)} />
      </Box>

      {tab === 'content' && (
        <Box flex={'1 1 auto'} overflow={'hidden'} p={isLessThan768 ? '16px' : '16px 24px'}>
          <SummaryContentTab id={id} onDelete={onDeleted} />
        </Box>
      )}
      {tab === 'state' && (
        <Box flex={'1 1 auto'} overflow={'hidden'}>
          <Box h={'100%'} overflowY={'auto'} p={isLessThan768 ? '16px' : '16px 24px'}>
            <SummaryStateTab id={id} />
          </Box>
        </Box>
      )}
      {tab === 'prompt' && (
        <Box flex={'1 1 auto'} overflow={'hidden'} p={isLessThan768 ? '16px' : '16px 24px'}>
          <SummaryPromptTab id={id} containerRef={ref} />
        </Box>
      )}
    </Stack>
  );
};

export const SummaryDetail = SummaryDetailFC;
